import React from 'react';
import {FaListAlt} from 'react-icons/fa';
import {Row,Col} from 'react-bootstrap';
import QrTable from 'main/table/QrTable';
import {RIconText,RCard} from '@putil-view/item.components';
import 'css/qr-manage.css';

const QrManage = () =>{
	return (
		<Row className="mt-6 col-lg-12 col-md-12 col-sm-12 col-xs-12 pl-0 pr-0 align-self-start pt-4">
			<Col xl={12} lg={12} md={12} sm={12} xs={12} className="qr-manage-col">
				<RCard title={
					<RIconText variant="lg">
						<FaListAlt/>
						<span>Manage Locker QR</span>
					</RIconText>
				}>
					<QrTable />
				</RCard>
			</Col>

		</Row>
	)
}

export default QrManage;
